module.exports = __webpack_public_path__ + "f1752d23b3e56620c40d1dec29c603e6.png";